import { render, staticRenderFns } from "./NimbusDrive.vue?vue&type=template&id=55c536c4&scoped=true&"
import script from "./NimbusDrive.vue?vue&type=script&lang=js&"
export * from "./NimbusDrive.vue?vue&type=script&lang=js&"
import style0 from "./NimbusDrive.vue?vue&type=style&index=0&id=55c536c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c536c4",
  null
  
)

export default component.exports